// TC5: Black — title types on character by character, cursor blinks
import { useCurrentFrame, useVideoConfig, interpolate, AbsoluteFill } from "remotion";
import { loadFont as loadMontserrat } from "@remotion/google-fonts/MontserratAlternates";

const { fontFamily: mont } = loadMontserrat("normal", { weights: ["900"], subsets: ["latin"] });

export const KedarnathTC5: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const text = "KEDARNATH";
  const totalTypeFrames = Math.round(1.8 * fps);
  const charsToShow = Math.floor(interpolate(frame, [0, totalTypeFrames], [0, text.length], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
  }));

  const cursorVisible = Math.floor(frame / Math.round(0.3 * fps)) % 2 === 0;
  const cursorOpacity = frame > Math.round(3.5 * fps) ? 0 : 1;

  const fadeOut = interpolate(frame, [Math.round(4.2 * fps), Math.round(5 * fps)], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const fadeIn = interpolate(frame, [0, Math.round(0.3 * fps)], [0, 1], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
  });

  const S = 1280 / 1920;
  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', left: 0, top: 0, width: 1920, height: 1080, transform: `scale(${S})`, transformOrigin: 'top left', background: "#000", display: "flex", alignItems: "center", justifyContent: "center", opacity: fadeIn * fadeOut }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{
          fontSize: 130,
          fontWeight: 900,
          fontFamily: mont,
          color: "#fff",
          letterSpacing: 20,
          textTransform: "uppercase",
        }}>
          {text.slice(0, charsToShow)}
        </span>
        {/* Cursor */}
        <span style={{
          width: 6,
          height: 100,
          background: "#fff",
          marginLeft: 8,
          opacity: cursorVisible ? cursorOpacity : 0,
          display: "inline-block",
        }} />
      </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
